import { createApp } from 'vue';
import VueMobileDetection from 'vue-mobile-detection';
import App from './App.vue';
import router from './router';

const app = createApp(App);
app.use(VueMobileDetection);
app.use(router).mount('#app');
